import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { TetrisThemeProvider } from '@pocketlaw/tetris';
import { localTheme } from 'shared/domains/common-ui/localTheme';
export function Providers(props) {
    const { children } = props;
    const { getTetrisTheme } = localTheme;
    return (<TetrisThemeProvider theme={getTetrisTheme()}>
      <I18nProvider i18n={i18n}>{children}</I18nProvider>
    </TetrisThemeProvider>);
}
